import React from "react";
import WidgetWrapper from "components/WidgetWrapper";
import FlexBetween from "components/FlexBetween";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import AddBusinessOutlinedIcon from "@mui/icons-material/AddBusinessOutlined";
import { useOrgAdmin } from "../hooks/useOrgAdmin";
import OrgGrid from "./OrgGrid";
import OrgForm from "./OrgForm";

function OrgAdmin() {
  const {
    open,
    editMode,
    currentOrg,
    handleOpen,
    handleEditOpen,
    handleClose,
    setOpen,
  } = useOrgAdmin();

  return (
    <WidgetWrapper>
      <FlexBetween>
        <Typography variant="h5">Organisations</Typography>
        <Button
          variant="contained"
          color="primary"
          sx={{
            borderRadius: "5px",
            fontSize: "12px",
            padding: "5px 10px",
          }}
          onClick={handleOpen}
        >
          <AddBusinessOutlinedIcon sx={{ mr: "0.5rem" }} />
          Add new Organisation
        </Button>
      </FlexBetween>
      <OrgGrid handleEditOpen={handleEditOpen} />

      {/* The Dialog component is a modal dialog that is displayed over the current page. */}

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>
          {editMode
            ? `Edit Organisation - ${currentOrg.name}`
            : "Add a New Organisation"}
        </DialogTitle>
        <DialogContent>
          <OrgForm
            editMode={editMode}
            currentOrg={currentOrg}
            setOpen={setOpen}
            handleClose={handleClose}
          />
        </DialogContent>
      </Dialog>
    </WidgetWrapper>
  );
}

export default OrgAdmin;
